import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderRecommendationHistoryRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const allRecommendations = await this.store.query('recommendation', {
      filter: {
        user: this.sessionContext.user.id,
        'requesting-app': 'STRATEGY_FINDER',
      },
      include: 'user',
      sort: '-created-at',
      page: {
        offset: 0,
      },
    });

    return {
      allRecommendations: allRecommendations,
    };
  }
}
